<template>
    <card shadow type="secondary">
        <div slot="header" class="bg-white border-0">
            <div class="row align-items-center">
                <div class="col-8">
                    <h3 class="mb-0">Bestehenden Nutzer zur Organisation hinzufügen</h3>
                </div>
            </div>
        </div>
        <template>
    <div class="row">
        <div class="col">
            <base-input alternative=""
                        required
                        label="E-Mail"
                        placeholder="mustermann@mustermail.de"
                        input-classes="form-control-alternative"
                        v-model="email"
                        @input="getUsers"
            />
            <p v-if="users.length === 1" class="text-muted">Folgender Nutzer wurde gefunden</p>
            <p v-else-if="users.length > 1" class="text-muted">Folgende Nutzer wurde gefunden. Bitte verwenden Sie die genaue E-mailadresse</p>
            <p v-else>Verwenden Sie die E-Mailadresse, die der Nutzer in einem anderen Socialguard Zugang verwendet.</p>
            <ul>
                <li v-for="user in users" :key="user.id">{{user.firstname}} {{user.lastname}} ({{user.id}}: {{user.email}})</li>
            </ul>
            <label class="form-control-label">
                Organisation
                <span>*</span></label>
            <select v-model="userCustomer.customer"
                    class="mb-3 custom-select form-control form-control-alternative form-control-lg">
                <!-- <option value="" disabled selected>Kunde</option> -->
                <option v-for="customer in $store.getters['customer/showCustomerCollection']" :key="customer.id" :value="customer">{{ customer.name }}
                </option>
            </select>
            <base-button :disabled="isLoading" v-if="userCustomer.user !== null && userCustomer.customer !== null" @click="addCusUser">{{userCustomer.user.firstname}} {{userCustomer.user.lastname}} zur Organisation {{userCustomer.customer.name}} hinzufügen</base-button>
        </div>
    </div>
        </template>
    </card>
</template>

<script>
    export default {
        name:"invite",
        data() {
            return {
                isLoading: false,
                userCustomer: {
                    user: null,
                    customer: null
                },
                users: [],
                email: ''
            }
        },
        created(){
            this.$store.dispatch('customer/getCustomerCollection');
        },
        methods: {
            getUsers() {
                if (this.validEmail(this.email)) {
                    return new Promise(() => {
                        const header = this.authHeader();
                        header['Content-Type'] = 'application/json';
                        let senddata = {email:this.email};
                        const requestOptions = {
                            method:'POST',
                            headers:header,
                            body:JSON.stringify(senddata)
                        };
                        fetch(process.env.VUE_APP_API_SERVER + `/api/users_by_mail`, requestOptions)
                            .then(this.handleResponse)
                            .then(response => {
                                this.users = response;
                                if(this.users.length ===1) this.userCustomer.user = this.users[0];
                            });
                    });
                }
            },
            validEmail(email) {
                let re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                return re.test(email);
            },
            addCusUser() {
                return new Promise((resolve, reject) => {
                    const header = this.authHeader();
                    header['Content-Type'] = 'application/json';
                    let senddata = {
                        user: this.userCustomer.user.id,
                        customer: this.userCustomer.customer.id
                    };
                    const requestOptions = {
                        method: 'POST',
                        headers: header,
                        body: JSON.stringify(senddata)
                    };
                    this.isLoading = true;
                    fetch(process.env.VUE_APP_API_SERVER + `/api/add_user_customer`, requestOptions)
                        .then(this.handleResponse)
                        .then(response => {
                                resolve(response);
                                this.$store.dispatch('alert/success','Organisation hinzugefügt.');
                            },
                            error => {
                                reject(error);
                                this.$store.dispatch('alert/error',error);
                                this.isLoading = false
                            });
                });
            },
        }
    }
</script>

<style scoped>

</style>